// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type { PostReviewCallAsrUpdateBody, BaseResponseVoid } from '../../../../types';

/**
 * updateAsrText
 *
 * @export
 * @tags 通话记录
 * @link [POST] /review/call/asr/update
 */
export function postReviewCallAsrUpdate(
    data: PostReviewCallAsrUpdateBody
): Promise<BaseResponseVoid>;
export function postReviewCallAsrUpdate(
    data: PostReviewCallAsrUpdateBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postReviewCallAsrUpdate(
    data: PostReviewCallAsrUpdateBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostReviewCallAsrUpdateBody, never, never>('/review/call/asr/update', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postReviewCallAsrUpdate',
    });
}

export const meta = [{ tags: ['通话记录'], path: '/review/call/asr/update', method: 'post' }];
